<div [formGroup]="travellerFormGroup">
    <div class="Edit">
        <div class="formRow">
            <div class="head">
                <mat-radio-group class="my-radio-button"
                                 [formControlName]="formNaming.identityTypeControlName"
                                 [disabled]="isTravellerReadonly"
                                 (ngModelChange)="applyIdentityTypeOnFormGroup()">
                    <mat-radio-button class="my-radio-button e2e-no-identity-document-radio"
                                      *ngIf="hasNoneOption && !apiServiceQualityMessage?.length" [value]="null">{{wording.noIdentityInfo}}</mat-radio-button>
                    <mat-radio-button class="my-radio-button e2e-passport-radio"
                                      [value]="identityInfoTypes.passport">{{wording.shortPassport}}</mat-radio-button>
                    <mat-radio-button class="my-radio-button e2e-nic-radio"
                                      [value]="identityInfoTypes.identityCard">{{wording.shortIdentityCard}}</mat-radio-button>
                    <mat-radio-button class="my-radio-button e2e-sfpd-radio"
                                      [value]="identityInfoTypes.secureFlightPassengerData">{{wording.shortSfpd}}</mat-radio-button>
                </mat-radio-group>
            </div>
        </div>

        <div class="formRow" *ngIf="travellerFormGroup.value[formNaming.identityTypeControlName]">
            <combobox-field [fieldConfig]="genderFieldSpec"
                            [items]="genderOptions"
                            [dropdownColorWhite]="true"
                            class="left_element e2e-gender-field"></combobox-field>
            <date-field *ngIf="hasBirthDateField"
                        [fieldConfig]="birthDateFieldSpec"
                        class="right_element e2e-birthdate-field"></date-field>
        </div>
        <div *ngIf="travellerFormGroup.value[formNaming.identityTypeControlName] === identityInfoTypes.passport">
            <div class="formRow">
                <text [fieldConfig]="passportCitizenshipFieldSpec"
                      maxLength="2"
                      class="left_element e2e-passport-citizenship-field"></text>
                <text [fieldConfig]="passportNumberFieldSpec"
                      class="right_element e2e-passport-number-field"></text>
            </div>
            <div class="formRow">
                <text [fieldConfig]="passportCountryFieldSpec"
                      maxLength="2"
                      class="left_element e2e-passport-country-field"></text>
                <date-field [fieldConfig]="passportValidityEndFieldSpec"
                            class="right_element e2e-passport-validity-end-field"></date-field>
            </div>
        </div>
        <div *ngIf="travellerFormGroup.value[formNaming.identityTypeControlName] === identityInfoTypes.identityCard">
            <div class="formRow">
                <text [fieldConfig]="identityCardCitizenshipFieldSpec"
                      maxLength="2"
                      class="left_element e2e-nic-citizenship-field"></text>
                <text [fieldConfig]="identityCardNumberFieldSpec"
                      class="right_element e2e-nic-number-field"></text>
            </div>
            <div class="formRow">
                <text [fieldConfig]="identityCardPlaceOfIssueFieldSpec"
                      maxLength="2"
                      class="left_element e2e-nic-place-of-issue-field"></text>
                <date-field [fieldConfig]="identityCardValidityEndFieldSpec"
                            class="right_element e2e-nic-validity-end-field"></date-field>
            </div>
        </div>
    </div>
</div>
